import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ClassType } from './class-type.model';
import { ClassTypePopupService } from './class-type-popup.service';
import { ClassTypeService } from './class-type.service';

@Component({
    selector: 'jhi-class-type-delete-dialog',
    templateUrl: './class-type-delete-dialog.component.html'
})
export class ClassTypeDeleteDialogComponent {

    classType: ClassType;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private classTypeService: ClassTypeService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['classType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.classTypeService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'classTypeListModification',
                content: 'Deleted an classType'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-class-type-delete-popup',
    template: ''
})
export class ClassTypeDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private classTypePopupService: ClassTypePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.classTypePopupService
                .open(ClassTypeDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type-delete-dialog.component.ts